export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (Object, authenticated, cummulativeSaleData, deliveriesData, deliveryDetailsData, formatDate, from, googleAds, heatmap, product, renderDollars, renderTimeInterval, salesData, salesTitle, to, username) {
      pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (authenticated) {
pug_html = pug_html + "\u003Cform class=\"report-form with-validation\"\u003E\u003Cdiv class=\"dates section\"\u003E\u003Cdiv class=\"grid\"\u003E\u003Cdiv\u003E\u003Clabel\u003EFrom\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"form-control datefield\""+" name=\"from\""+pug_attr("value", formatDate(from), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel\u003ETo\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"form-control datefield\""+" name=\"to\""+pug_attr("value", formatDate(to), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"action deliveries\"\u003EDelivery summary\u003C\u002Fbutton\u003E\u003Cbutton class=\"action delivery-dtls\"\u003EDelivery details\u003C\u002Fbutton\u003E\u003Cbutton class=\"action sales\"\u003ESales summary\u003C\u002Fbutton\u003E\u003Cbutton class=\"action orders\"\u003EOrder summary\u003C\u002Fbutton\u003E\u003Cbutton class=\"action weeklySales\"\u003EWeekly sales chart\u003C\u002Fbutton\u003E\u003Cbutton class=\"action weeklyOnlineSales\"\u003EWeekly online sales chart\u003C\u002Fbutton\u003E\u003Cbutton class=\"action heatmap\"\u003EHeatmap\u003C\u002Fbutton\u003E\u003Cbutton class=\"action wrbGoogleAds\"\u003EGoogle ads report\u003C\u002Fbutton\u003E\u003Cbutton class=\"action best-sellers\" data-usedelivery=\"0\"\u003EBest sellers (by sale date)\u003C\u002Fbutton\u003E\u003Cbutton class=\"action best-sellers\" data-usedelivery=\"1\"\u003EBest sellers (by order date)\u003C\u002Fbutton\u003E\u003Cbutton class=\"action cummulativeSales\" data-type=\"dollars\"\u003ECummulative sales (dollars)\u003C\u002Fbutton\u003E\u003Cbutton class=\"action cummulativeSales\" data-type=\"orders\"\u003ECummulative sales (orders)\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003Cdiv class=\"results\"\u003E";
if (deliveriesData) {
pug_html = pug_html + "\u003Ch2\u003EDelivery summary\u003C\u002Fh2\u003E\u003Ctable\u003E\u003Cthead\u003E\u003Cth\u003EDriver\u003C\u002Fth\u003E\u003Cth\u003EDeliveries\u003C\u002Fth\u003E\u003C\u002Fthead\u003E";
// iterate deliveriesData
;(function(){
  var $$obj = deliveriesData;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var line = $$obj[pug_index0];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = line.driver) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = line.deliveries) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var line = $$obj[pug_index0];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = line.driver) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = line.deliveries) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E";
}
if (deliveryDetailsData) {
pug_html = pug_html + "\u003Ch2\u003EDelivery Details\u003C\u002Fh2\u003E\u003Ctable class=\"delivery-details\"\u003E";
// iterate Object.keys(deliveryDetailsData)
;(function(){
  var $$obj = Object.keys(deliveryDetailsData);
  if ('number' == typeof $$obj.length) {
      for (var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++) {
        var driver = $$obj[pug_index1];
pug_html = pug_html + "\u003Cthead\u003E\u003Cth\u003E" + (pug_escape(null == (pug_interp = driver) ? "" : pug_interp)) + "\u003C\u002Fth\u003E\u003Cth\u003EDriving\u003C\u002Fth\u003E\u003Cth\u003EDelivery\u003C\u002Fth\u003E\u003Cth\u003ETotal\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003C\u002Fthead\u003E";
// iterate deliveryDetailsData[driver]
;(function(){
  var $$obj = deliveryDetailsData[driver];
  if ('number' == typeof $$obj.length) {
      for (var pug_index2 = 0, $$l = $$obj.length; pug_index2 < $$l; pug_index2++) {
        var d = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = d.ts) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous - d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = d.address) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca" + (pug_attr("href", `#/orders/view/${d.order_id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = d.order_number) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index2 in $$obj) {
      $$l++;
      var d = $$obj[pug_index2];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = d.ts) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous - d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = d.address) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca" + (pug_attr("href", `#/orders/view/${d.order_id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = d.order_number) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

      }
  } else {
    var $$l = 0;
    for (var pug_index1 in $$obj) {
      $$l++;
      var driver = $$obj[pug_index1];
pug_html = pug_html + "\u003Cthead\u003E\u003Cth\u003E" + (pug_escape(null == (pug_interp = driver) ? "" : pug_interp)) + "\u003C\u002Fth\u003E\u003Cth\u003EDriving\u003C\u002Fth\u003E\u003Cth\u003EDelivery\u003C\u002Fth\u003E\u003Cth\u003ETotal\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003C\u002Fthead\u003E";
// iterate deliveryDetailsData[driver]
;(function(){
  var $$obj = deliveryDetailsData[driver];
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var d = $$obj[pug_index3];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = d.ts) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous - d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = d.address) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca" + (pug_attr("href", `#/orders/view/${d.order_id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = d.order_number) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var d = $$obj[pug_index3];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = d.ts) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous - d.driving_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"nobreak\"\u003E" + (pug_escape(null == (pug_interp = renderTimeInterval(d.elapsed_seconds_from_previous)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = d.address) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Ca" + (pug_attr("href", `#/orders/view/${d.order_id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = d.order_number) ? "" : pug_interp)) + "\u003C\u002Fa\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftable\u003E";
}
if (salesData) {
pug_html = pug_html + "\u003Ch2\u003E" + (pug_escape(null == (pug_interp = salesTitle) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003Ctable class=\"sales-summary\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EProduct\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003Cth\u003ESales\u003C\u002Fth\u003E";
// iterate salesData.addons
;(function(){
  var $$obj = salesData.addons;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var addon = $$obj[pug_index4];
pug_html = pug_html + "\u003Cth\u003E" + (pug_escape(null == (pug_interp = addon) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var addon = $$obj[pug_index4];
pug_html = pug_html + "\u003Cth\u003E" + (pug_escape(null == (pug_interp = addon) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cth\u003ETotal\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate salesData.products
;(function(){
  var $$obj = salesData.products;
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var product = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E";
if (product.id) {
pug_html = pug_html + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"expand-product clickable\""+pug_attr("data-product", product.name, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (product.id) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${product.id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.numericId) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + ((pug_escape(null == (pug_interp = product.count) ? "" : pug_interp)) + " orders, avg " + (pug_escape(null == (pug_interp = renderDollars(product.sales / product.count)) ? "" : pug_interp)));
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.sales)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
// iterate salesData.addons
;(function(){
  var $$obj = salesData.addons;
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var addon = $$obj[pug_index6];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.addons[addon])) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var addon = $$obj[pug_index6];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.addons[addon])) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.totalSales)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var product = $$obj[pug_index5];
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E";
if (product.id) {
pug_html = pug_html + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp));
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"expand-product clickable\""+pug_attr("data-product", product.name, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
if (product.id) {
pug_html = pug_html + "\u003Ca" + (" class=\"clickable\""+pug_attr("href", `#/orders/view/${product.id}`, true, true)) + "\u003E" + (pug_escape(null == (pug_interp = product.numericId) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + ((pug_escape(null == (pug_interp = product.count) ? "" : pug_interp)) + " orders, avg " + (pug_escape(null == (pug_interp = renderDollars(product.sales / product.count)) ? "" : pug_interp)));
}
pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.sales)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
// iterate salesData.addons
;(function(){
  var $$obj = salesData.addons;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var addon = $$obj[pug_index7];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.addons[addon])) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var addon = $$obj[pug_index7];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.addons[addon])) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.totalSales)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003Ctfoot\u003E\u003Ctr\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003Cth\u003E\u003C\u002Fth\u003E\u003Cth\u003ESales\u003C\u002Fth\u003E";
// iterate salesData.addons
;(function(){
  var $$obj = salesData.addons;
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var addon = $$obj[pug_index8];
pug_html = pug_html + "\u003Cth\u003E" + (pug_escape(null == (pug_interp = addon) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var addon = $$obj[pug_index8];
pug_html = pug_html + "\u003Cth\u003E" + (pug_escape(null == (pug_interp = addon) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cth\u003E\u003Cstrong\u003ETotal\u003C\u002Fstrong\u003E\u003C\u002Fth\u003E\u003C\u002Ftr\u003E";
var product = salesData.total;
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003ETotal\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = product.count) ? "" : pug_interp)) + " orders\u003C\u002Ftd\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.sales)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
// iterate salesData.addons
;(function(){
  var $$obj = salesData.addons;
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var addon = $$obj[pug_index9];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.addons[addon])) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var addon = $$obj[pug_index9];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.addons[addon])) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = renderDollars(product.totalSales)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftfoot\u003E\u003C\u002Ftable\u003E";
}
if (heatmap) {
pug_html = pug_html + "\u003Cdiv\u003E" + (null == (pug_interp = heatmap) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
if (googleAds) {
pug_html = pug_html + "\u003Cp\u003EDates use Pacific Time (GMT-08:00)\u003C\u002Fp\u003E";
// iterate Object.keys(googleAds)
;(function(){
  var $$obj = Object.keys(googleAds);
  if ('number' == typeof $$obj.length) {
      for (var pug_index10 = 0, $$l = $$obj.length; pug_index10 < $$l; pug_index10++) {
        var campaign = $$obj[pug_index10];
var data = googleAds[campaign];
var totalConversions = 0, totalDollars = 0;
pug_html = pug_html + "\u003Ch2\u003E" + (pug_escape(null == (pug_interp = campaign) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003Ctable class=\"google-ads-table\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EDate\u003C\u002Fth\u003E\u003Cth class=\"right\"\u003EConversions (sales)\u003C\u002Fth\u003E\u003Cth class=\"right\"\u003EConversion value\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate Object.keys(data).sort()
;(function(){
  var $$obj = Object.keys(data).sort();
  if ('number' == typeof $$obj.length) {
      for (var pug_index11 = 0, $$l = $$obj.length; pug_index11 < $$l; pug_index11++) {
        var day = $$obj[pug_index11];
var d = data[day]
totalConversions += d.conversions;
totalDollars += d.conversion_value;
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = day) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = d.conversions) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars(d.conversion_value)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index11 in $$obj) {
      $$l++;
      var day = $$obj[pug_index11];
var d = data[day]
totalConversions += d.conversions;
totalDollars += d.conversion_value;
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = day) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = d.conversions) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars(d.conversion_value)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

var days = Object.keys(data).length
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003ETotal days: " + (pug_escape(null == (pug_interp = days) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = totalConversions) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars(totalDollars)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
if (days > 0) {
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003EPer day averages\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = (totalConversions / days).toFixed(2)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars((totalDollars / days).toFixed(2))) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index10 in $$obj) {
      $$l++;
      var campaign = $$obj[pug_index10];
var data = googleAds[campaign];
var totalConversions = 0, totalDollars = 0;
pug_html = pug_html + "\u003Ch2\u003E" + (pug_escape(null == (pug_interp = campaign) ? "" : pug_interp)) + "\u003C\u002Fh2\u003E\u003Ctable class=\"google-ads-table\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EDate\u003C\u002Fth\u003E\u003Cth class=\"right\"\u003EConversions (sales)\u003C\u002Fth\u003E\u003Cth class=\"right\"\u003EConversion value\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate Object.keys(data).sort()
;(function(){
  var $$obj = Object.keys(data).sort();
  if ('number' == typeof $$obj.length) {
      for (var pug_index12 = 0, $$l = $$obj.length; pug_index12 < $$l; pug_index12++) {
        var day = $$obj[pug_index12];
var d = data[day]
totalConversions += d.conversions;
totalDollars += d.conversion_value;
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = day) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = d.conversions) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars(d.conversion_value)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index12 in $$obj) {
      $$l++;
      var day = $$obj[pug_index12];
var d = data[day]
totalConversions += d.conversions;
totalDollars += d.conversion_value;
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E" + (pug_escape(null == (pug_interp = day) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = d.conversions) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars(d.conversion_value)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

var days = Object.keys(data).length
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003ETotal days: " + (pug_escape(null == (pug_interp = days) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = totalConversions) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars(totalDollars)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
if (days > 0) {
pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003EPer day averages\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = (totalConversions / days).toFixed(2)) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"right\"\u003E" + (pug_escape(null == (pug_interp = renderDollars((totalDollars / days).toFixed(2))) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
}
pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E";
    }
  }
}).call(this);

}
pug_html = pug_html + "\u003Cdiv class=\"cummulative-sales\"\u003E";
if (cummulativeSaleData) {
pug_html = pug_html + "\u003Ch2\u003ECummulative sales\u003C\u002Fh2\u003E\u003Ctable class=\"cummulative-sales-table\"\u003E\u003Cthead\u003E\u003Cth\u003E\u003C\u002Fth\u003E";
// iterate cummulativeSaleData.years
;(function(){
  var $$obj = cummulativeSaleData.years;
  if ('number' == typeof $$obj.length) {
      for (var pug_index13 = 0, $$l = $$obj.length; pug_index13 < $$l; pug_index13++) {
        var year = $$obj[pug_index13];
pug_html = pug_html + "\u003Cth\u003E" + (pug_escape(null == (pug_interp = year) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index13 in $$obj) {
      $$l++;
      var year = $$obj[pug_index13];
pug_html = pug_html + "\u003Cth\u003E" + (pug_escape(null == (pug_interp = year) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fthead\u003E\u003Ctbody\u003E";
// iterate cummulativeSaleData.days
;(function(){
  var $$obj = cummulativeSaleData.days;
  if ('number' == typeof $$obj.length) {
      for (var pug_index14 = 0, $$l = $$obj.length; pug_index14 < $$l; pug_index14++) {
        var day = $$obj[pug_index14];
pug_html = pug_html + "\u003Ctr\u003E\u003Cth\u003E" + (pug_escape(null == (pug_interp = day) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
// iterate cummulativeSaleData.years
;(function(){
  var $$obj = cummulativeSaleData.years;
  if ('number' == typeof $$obj.length) {
      for (var pug_index15 = 0, $$l = $$obj.length; pug_index15 < $$l; pug_index15++) {
        var year = $$obj[pug_index15];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = cummulativeSaleData.data[year][day]) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index15 in $$obj) {
      $$l++;
      var year = $$obj[pug_index15];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = cummulativeSaleData.data[year][day]) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index14 in $$obj) {
      $$l++;
      var day = $$obj[pug_index14];
pug_html = pug_html + "\u003Ctr\u003E\u003Cth\u003E" + (pug_escape(null == (pug_interp = day) ? "" : pug_interp)) + "\u003C\u002Fth\u003E";
// iterate cummulativeSaleData.years
;(function(){
  var $$obj = cummulativeSaleData.years;
  if ('number' == typeof $$obj.length) {
      for (var pug_index16 = 0, $$l = $$obj.length; pug_index16 < $$l; pug_index16++) {
        var year = $$obj[pug_index16];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = cummulativeSaleData.data[year][day]) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index16 in $$obj) {
      $$l++;
      var year = $$obj[pug_index16];
pug_html = pug_html + "\u003Ctd\u003E" + (pug_escape(null == (pug_interp = cummulativeSaleData.data[year][day]) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"chartelt\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cform class=\"authenticate-form with-validation\"\u003E\u003Cdiv class=\"authenticate section\"\u003E\u003Cdiv class=\"grid\"\u003E\u003Cdiv\u003E\u003Clabel\u003EUser\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"form-control\""+" name=\"y\""+pug_attr("value", username, true, true)+pug_attr("disabled", true, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel\u003EPassword\u003C\u002Flabel\u003E\u003Cinput class=\"form-control\" type=\"password\" name=\"x\" autocomplete=\"new-password\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"action confirm-password\"\u003EConfirm password\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "Object" in locals_for_with ?
        locals_for_with.Object :
        typeof Object !== 'undefined' ? Object : undefined, "authenticated" in locals_for_with ?
        locals_for_with.authenticated :
        typeof authenticated !== 'undefined' ? authenticated : undefined, "cummulativeSaleData" in locals_for_with ?
        locals_for_with.cummulativeSaleData :
        typeof cummulativeSaleData !== 'undefined' ? cummulativeSaleData : undefined, "deliveriesData" in locals_for_with ?
        locals_for_with.deliveriesData :
        typeof deliveriesData !== 'undefined' ? deliveriesData : undefined, "deliveryDetailsData" in locals_for_with ?
        locals_for_with.deliveryDetailsData :
        typeof deliveryDetailsData !== 'undefined' ? deliveryDetailsData : undefined, "formatDate" in locals_for_with ?
        locals_for_with.formatDate :
        typeof formatDate !== 'undefined' ? formatDate : undefined, "from" in locals_for_with ?
        locals_for_with.from :
        typeof from !== 'undefined' ? from : undefined, "googleAds" in locals_for_with ?
        locals_for_with.googleAds :
        typeof googleAds !== 'undefined' ? googleAds : undefined, "heatmap" in locals_for_with ?
        locals_for_with.heatmap :
        typeof heatmap !== 'undefined' ? heatmap : undefined, "product" in locals_for_with ?
        locals_for_with.product :
        typeof product !== 'undefined' ? product : undefined, "renderDollars" in locals_for_with ?
        locals_for_with.renderDollars :
        typeof renderDollars !== 'undefined' ? renderDollars : undefined, "renderTimeInterval" in locals_for_with ?
        locals_for_with.renderTimeInterval :
        typeof renderTimeInterval !== 'undefined' ? renderTimeInterval : undefined, "salesData" in locals_for_with ?
        locals_for_with.salesData :
        typeof salesData !== 'undefined' ? salesData : undefined, "salesTitle" in locals_for_with ?
        locals_for_with.salesTitle :
        typeof salesTitle !== 'undefined' ? salesTitle : undefined, "to" in locals_for_with ?
        locals_for_with.to :
        typeof to !== 'undefined' ? to : undefined, "username" in locals_for_with ?
        locals_for_with.username :
        typeof username !== 'undefined' ? username : undefined));
    ;;return pug_html;}